module.exports = __webpack_public_path__ + "static/media/mobile_preview.a88befb8.png";